export default "__VITE_ASSET__DuMmigIE__"